import React from 'react';
import { Route } from 'react-router-dom';
import { ConnectedRouter } from 'connected-react-router';

import { MuiThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { browserHistory } from 'config/store';
import { createCustomColorTheme } from 'bento-ordering/base/theme/OnlineOrderingTheme';
import { FlagsProvider } from 'bento-ordering/base/utils/flags';
import { flags } from 'bento-ordering/base/constants/flags';
import getApp from 'base-ordering/utils/getApp';

/**
 * The component wraps the App component with Router so
 * the App component can access to location props from
 * react-route.
 */
class AppContainer extends React.PureComponent {
  static propTypes = {
    primaryColor: PropTypes.string,
    secondaryColor: PropTypes.string,
    bodyColor: PropTypes.string,
    isStaff: PropTypes.bool
  };

  render() {
    const theme = createCustomColorTheme(this.props);
    let App = null;
    try {
      App = getApp();
    } catch (e) {
      console.error(e);
    }
    return (
      <FlagsProvider flags={{ ...flags, isStaff: this.props.isStaff }}>
        <MuiThemeProvider theme={theme}>
          <ConnectedRouter history={browserHistory}>
            {App !== null ? (
              <Route render={props => <App {...props} />} />
            ) : (
              <div>That route is not supported</div>
            )}
          </ConnectedRouter>
          <CssBaseline />
        </MuiThemeProvider>
      </FlagsProvider>
    );
  }
}

const mapStateToProps = state => {
  const { account, user } = state;

  return {
    primaryColor: get(account, 'processed_theme_options.primary_color'),
    secondaryColor: get(account, 'processed_theme_options.accent_color'),
    bodyColor: get(account, 'processed_theme_options.body_color'),
    isStaff: user.is_staff
  };
};

export default connect(mapStateToProps)(AppContainer);
